$(function(){

});

loadMore = (e) =>{
  var $load_more_btn = $(e);

  var $collection_container = $('.ex-collection-grid');
  var $next_url = $load_more_btn.attr('data-next-url');

  var $load_more_spinner = $('.ex-load-more-spinner');
  $.ajax({
    url: $next_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function() {
      $load_more_btn.hide();
      $load_more_spinner.show();
    }
  }).done(function(d){
    $load_more_spinner.hide();
    var $new_products = $(d).find(".ex-collection-grid");
    var $new_url = $(d).find('.ex-load-more-btn').attr('data-next-url');

    var $urlSplit = $next_url.split('?');
    var $param = $urlSplit[$urlSplit.length-1];


    window.history.replaceState(null, null, `?${$param}`);
    $collection_container.append($new_products.children());
    $collection_container.addClass('pag-loaded');

    if($new_url){
      $load_more_btn.attr('data-next-url', $new_url);
      $load_more_btn.show();
    }
  }).fail(function(e){
    console.log('you',e);
  });
}

loadPrevious = (e) =>{
  var $load_previous_btn = $(e);

  var $collection_container = $('.ex-collection-grid');
  var $previous_url = $load_previous_btn.attr('data-previous-url');

  var $load_previous_spinner = $('.ex-load-previous-spinner');
  $.ajax({
    url: $previous_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function() {
      $load_previous_btn.hide();
      $load_previous_spinner.show();
    }
  }).done(function(d){
    $load_previous_spinner.hide();
    var $new_products = $(d).find(".ex-collection-grid");
    var $new_url = $(d).find('.ex-load-previous-btn').attr('data-previous-url');

    var $urlSplit = $previous_url.split('?');
    var $param = $urlSplit[$urlSplit.length-1];


    window.history.replaceState(null, null, `?${$param}`);
    $collection_container.prepend($new_products.children());
    $collection_container.addClass('pag-loaded');


    if($new_url){
      $load_previous_btn.attr('data-previous-url', $new_url);
      $load_previous_btn.show();
    }
  }).fail(function(e){
    console.log('you',e);
  });
}
function isCollectionTemplate() {
  if (!document.body) return false;
  return ['template-collection', 'template-search'].some(cls =>
    document.body.classList.contains(cls)
  );
}

function isBackForward(evt) {
  if (evt && typeof evt.persisted === 'boolean' && evt.persisted) return true;
  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation');
    if (nav && nav.length && nav[0].type === 'back_forward') return true;
  } catch(e){}
  return false;
}

// scroll grid section so its middle is centered in viewport
function scrollGridToCenter(offsetPx) {
  var grid = document.querySelector('.ex-collection-grid');
  if (!grid) return;

  var rect = grid.getBoundingClientRect();
  var scrollY = window.scrollY || window.pageYOffset;

  var gridMiddle = rect.top + scrollY + (rect.height / 2);
  var target = gridMiddle - (window.innerHeight / 2) - (offsetPx || 0);

  // clamp to page limits
  var maxTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  if (target > maxTop) target = maxTop;
  if (target < 0) target = 0;

  requestAnimationFrame(function () {
    window.scrollTo({ top: target, left: 0, behavior: 'auto' });
  });
}

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

window.addEventListener('pageshow', function (evt) {
  if (!isCollectionTemplate()) return;
  if (isBackForward(evt)) {
    // adjust offset if you have a sticky header, e.g. 64
    scrollGridToCenter(0);
  }
});

// fallback for browsers that don’t fire pageshow properly
document.addEventListener('DOMContentLoaded', function () {
  if (!isCollectionTemplate()) return;
  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation');
    if (nav && nav.length && nav[0].type === 'back_forward') {
      scrollGridToCenter(0);
    }
  } catch(e){}
});